/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.giftCards.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class GiftCardModel(
    /** A unique ID identifying this reward */
    @SerialName("id")
    val id: Int,

    @SerialName("points")
    val points: Int?,

    /** The publication date of this offer. */
    @SerialName("publish_at")
    val publishAt: String?,

    /** The expiration date of this offer. */
    @SerialName("expires_at")
    val expiresAt: String?,

    /** Whether this offer is currently published or not. */
    @SerialName("is_published")
    val isPublished: Boolean?,

    /** Whether this is a convertible coupon. Convertible coupons are automatically added to the customers account when the point threshold is met. The points are automatically deducted from the users&#39; account.  */
    @SerialName("coupon_convertible")
    val couponConvertible: Boolean?,

    /** The real value  (in $) of this gift card */
    @SerialName("real_value")
    val realValue: Double?,

    /** The discount value (in $) of this gift card */
    @SerialName("discount_value")
    val discountValue: Double?,

    @SerialName("multip_factor")
    val multipFactor: Double?,

    @SerialName("min_purchase")
    val minPurchase: Double?,

    @SerialName("max_purchase")
    val maxPurchase: Double?,

    @SerialName("apps_only")
    val appsOnly: Boolean?,

    @SerialName("offer_frequency_id")
    val offerFrequencyId: Int?,

    @SerialName("freq_details")
    val freqDetails: List<String>?,

    @SerialName("peak_from")
    val peakFrom: String?,

    @SerialName("peak_to")
    val peakTo: String?,

    /** The offer type. This is a gift card.  */
    @SerialName("type")
    val type: String?,

    /** The gift card title. */
    @SerialName("title")
    val title: String?,

    /** The gift card description. */
    @SerialName("description")
    val description: String?,

    /** The unique slug for this gift card */
    @SerialName("slug")
    val slug: String?,

    /** The images attached to this gift ard. There are 3 available sizes: thumbnail, medium, and large.  */
    @SerialName("images")
    val images: List<ImageModel>?,

    /** Whether this gift card ever expires or not. If false, this gift card is available indefinitely (provided any other requirements are met)  */
    @SerialName("never_expires_flag")
    val neverExpiresFlag: Boolean?,

    /** The terms and conditions attached to this gift card. */
    @SerialName("terms_conditions")
    val termsConditions: String?,

    /** The external link attached to this gift card. */
    @SerialName("link")
    val link: String?,

    /** A list of translations of this gift card into different languages. */
    @SerialName("offer_languages")
    val offerLanguages: List<GiftCardTranslation>?,

    /** A list of possible actions to perform on this gift card. */
    @SerialName("actions")
    val actions: List<GiftCardAction>?
) : Model()
